import React from 'react'
import { formatInBrazilianDate } from 'utils/functions'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayCompanyRelations(props) {
  const { questionData } = props
  const classes = styles()

  const buildCompanyRelation = (activityInfo) => {
    return (
      <div className={classes.answersContainer} key={activityInfo.key}>
        <p>
          <span>Atividade Desempenhada: </span>
          {activityInfo.developed_activities}
        </p>
        <p>
          <span>Período: </span>
          {`${formatInBrazilianDate(activityInfo.start_date)} - ${
            activityInfo.end_date === '' || activityInfo.end_date === null
              ? 'atualmente'
              : formatInBrazilianDate(activityInfo.end_date)
          }`}
        </p>
        {activityInfo.exit_reason ? (
          <p>
            <span>Motivo da saída: </span>
            {activityInfo.exit_reason}
          </p>
        ) : null}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento das Atividades:</h3>
      <DisplayAnswerItems
        answerData={questionData}
        noDataMessage="O assessor informou que não possui relação com outras empresas de investimento."
        funcBuildItem={buildCompanyRelation}
      />
    </div>
  )
}

export default DisplayCompanyRelations
